import { createClient, type SupabaseClient } from '@supabase/supabase-js'

const url = import.meta.env.VITE_SUPABASE_URL as string | undefined
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined

/**
 * Cliente de Supabase, o null si la app se compiló sin credenciales.
 *
 * Que pueda ser null es a propósito: sin conexión a la base de datos la app
 * sigue funcionando con el reto que lleva incluido, y el panel de
 * administración simplemente avisa de que falta configurarla.
 */
export const supabase: SupabaseClient | null =
  url && anonKey
    ? createClient(url, anonKey, {
        auth: { persistSession: true, autoRefreshToken: true },
      })
    : null

export const supabaseEnabled = supabase !== null
